import React, { useState, useContext } from "react";
import { useHistory, NavLink } from "react-router-dom";
import Switch from "react-switch";
//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  pagination,
  paginationLoading,
  showingData,
  searchedShowingData,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDelete } from "react-icons/md";

//context consumer
import { FoodContext } from "../../../../../contexts/Food";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const PackingTypeList = () => {
  const { t } = useTranslation();
  const history = useHistory();
  //getting context values here

  let {
    //common
    loading,
    setLoading,

    //packing
    packingTypeList,
    setPackingTypeList,
    setPaginatedPackingType,
    packingTypeForSearch,
    setPackingTypeForStatus,
    setPackingTypeForSearch,

    dataPaginating, 
    setDataPaginating
  } = useContext(FoodContext);

  // States hook here

  //search result
  let [ searchedPackingType,  setSearchedPackingType] = useState({
    list: null,
    searched: false,
  });

  //search Variation here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
       setSearchedPackingType({ ... searchedPackingType, searched: false });
    } else {
      let searchedList =  packingTypeForSearch.filter((item) => {
        let lowerCaseItemName = item.name.toLowerCase();
        return lowerCaseItemName.includes(searchInput);
      });
       setSearchedPackingType({
        ... searchedPackingType,
        list: searchedList,
        searched: true,
      });
    }
  };

  //delete confirmation modal of variation
  const handleDeleteConfirmation = (slug) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary rounded"
                onClick={() => {
                  handleDeleteVariation(slug);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button
                className="btn btn-success ml-2 px-3 rounded"
                onClick={onClose}
              >
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  //delete variation here
  const handleDeleteVariation = (slug) => {
    setLoading(true);
    const variationUrl = BASE_URL + `/settings/delete-variation/${slug}`;
    return axios
      .get(variationUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        if (res.data === "data exist") {
          setLoading(false);
          toast.error(
            `${_t(t("Please remove this variation from food item first"))}`,
            {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            }
          );
        } else {
          setPackingTypeList(res.data[0]);
          setPackingTypeForSearch(res.data[1]);
          setPackingTypeForStatus(res.data[2]);
           setSearchedPackingType({
            ... searchedPackingType,
            list: res.data[1],
          });
          setLoading(false);
          toast.success(`${_t(t("Variation has been deleted successfully"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

	//status
	const handleStatus = (item) =>{
		setDataPaginating(true);
		const statusUrl = BASE_URL + `/settings/product-packing-status`;
		const formData = {
			id: item.id,
			status: item.status ? 0 : 1
		}
		return axios
			.post(statusUrl, formData, {
				headers: { Authorization: `Bearer ${getCookie()}` },
			})
			.then((res) => {
				 setPackingTypeList(res.data[0]);
				 setPackingTypeForSearch(res.data[1]);
         setPackingTypeForStatus(res.data[2]);
				 setSearchedPackingType({
					... searchedPackingType,
					list: res.data[1],
				});
				setDataPaginating(false);
				toast.success(`${_t(t("Status has been updated successfully"))}`, {
					position: "bottom-center",
					autoClose: 10000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
          className:"text-center toast-notification",
				});
			}).catch((err)=>{
				setDataPaginating(false);
				toast.error(`${_t(t("Please try again"))}`, {
					position: "bottom-center",
					autoClose: 10000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
          className:"text-center toast-notification",
				});
			})
	}

  return (
    <>
      <Helmet>
        <title>{_t(t("Packing Type"))}</title>
      </Helmet>

      {/* Add modal Ends*/}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="fk-scroll--pos-table-menu" data-simplebar>
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    <div key="fragment3">
                      {/* next page data spin loading */}
                      <CustomSpinLoader loading={loading || dataPaginating} />
                      {/* spin loading ends */}

                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-6 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb d-flex justify-content-between align-items-center">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {! searchedPackingType.searched
                                  ? _t(t("Packing Type List"))
                                  : _t(t("Search Result"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-6">
                          <div className="row gx-3 align-items-center">
                            {/* Search group */}
                            <div className="col-md-9 t-mb-15 mb-md-0">
                              <div className="input-group">
                                <div className="form-file">
                                  <input
                                    type="text"
                                    className="form-control border-0 form-control--light-1 rounded-left"
                                    placeholder={_t(t("Search")) + ".."}
                                    onChange={handleSearch}
                                  />
                                </div>
                                <button
                                  className="btn btn-primary rounded-right"
                                  type="button"
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </div>
                            </div>

                            {/* Add group modal trigger button */}
                            <div className="col-md-3 text-md-right">
                              <NavLink
                                to="/dashboard/manage/food/packing-type-add"
																className="btn btn-primary btn-lg rounded btn-block sm-text"
                              >
                                {_t(t("ADD NEW"))}
                              </NavLink>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Table */}
                      <div className="table-responsive">
                        <table className="table table-bordered table-hover min-table-height">
                          <thead className="align-middle">
                            <tr>
                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("S/L"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Name"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Short Name"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Action"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Status"))}
                              </th>
                            </tr>
                          </thead>
                          <tbody className="align-middle">
                            {/* loop here, logic === !search && haveData && haveDataLegnth > 0*/}
                            {! searchedPackingType.searched
                              ? [
                                  packingTypeList && [
                                    packingTypeList?.data?.length === 0 ? (
                                      <tr className="align-middle">
                                        <td
                                          scope="row"
                                          colSpan="6"
                                          className="xsm-text align-middle text-center"
                                        >
                                          {_t(t("No data available"))}
                                        </td>
                                      </tr>
                                    ) : ( Array.isArray( packingTypeList.data) &&
                                       packingTypeList.data.map((item, index) => {
                                        return (
                                          <tr
                                            className="align-middle"
                                            key={index}
                                          >
                                            <th
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              {index +
                                                1 +
                                                ( packingTypeList.current_page -
                                                  1) *
                                                   packingTypeList.per_page}
                                            </th>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {item.name}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {item.short_code}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              <NavLink
                                                to={"/dashboard/manage/food/packing-type-edit/" + item.id}
																								className="btn btn-primary rounded-sm edit-btn del-btn"
                                              >
                                                <i
                                                  className="fa fa-pencil edit-icon"
                                                  aria-hidden="true"
                                                ></i>
                                              </NavLink>
                                            </td>
                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              <Switch
																								onChange={()=>handleStatus(item)}
																								checked={item.status === 1}
																								className="react-switch ml-2"
																								name="status"
																								height={20}
																								width={42}
																								offColor="#ee5253"                        
																							/>
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ),
                                  ],
                                ]
                              : [
                                  /* searched data, logic === haveData*/
                                   searchedPackingType && [
                                     searchedPackingType.list.length === 0 ? (
                                      <tr className="align-middle">
                                        <td
                                          scope="row"
                                          colSpan="6"
                                          className="xsm-text align-middle text-center"
                                        >
                                          {_t(t("No data available"))}
                                        </td>
                                      </tr>
                                    ) : (
                                       searchedPackingType.list.map(
                                        (item, index) => {
                                          return (
                                            <tr
                                              className="align-middle"
                                              key={index}
                                            >
                                              <th
                                                scope="row"
                                                className="xsm-text text-capitalize align-middle text-center"
                                              >
                                                {index +
                                                  1 +
                                                  ( packingTypeList.current_page -
                                                    1) *
                                                     packingTypeList.per_page}
                                              </th>

                                              <td className="xsm-text align-middle text-center">
                                                {item.name}
                                              </td>

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {item.short_code}
                                              </td>

                                              <td className="xsm-text text-capitalize align-middle text-center">
																								<NavLink
																									to={"/dashboard/manage/food/packing-type-edit/" + item.id}
																									className="btn btn-primary rounded-sm edit-btn del-btn"
																								>
																									<i
																										className="fa fa-pencil edit-icon"
																										aria-hidden="true"
																									></i>
																								</NavLink>
                                              </td>
                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                <Switch
                                                  onChange={()=>handleStatus(item)}
                                                  checked={item.status === 1}
                                                  className="react-switch ml-2"
                                                  name="status"
                                                  height={20}
                                                  width={42}
                                                  offColor="#ee5253"                        
                                                />
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )
                                    ),
                                  ],
                                ]}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* pagination loading effect */}
              {loading === true
                ? paginationLoading()
                : [
                    // logic === !searched
                    ! searchedPackingType.searched ? (
                      <div key="fragment4">
                        <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                          <div className="row align-items-center t-pl-15 t-pr-15">
                            <div className="col-md-7 t-mb-15 mb-md-0">
                              {/* pagination function */}
                              {pagination( packingTypeList,  setPaginatedPackingType)}
                            </div>
                            <div className="col-md-5">
                              <ul className="t-list d-flex justify-content-md-end align-items-center">
                                <li className="t-list__item">
                                  <span className="d-inline-block sm-text">
                                    {showingData( packingTypeList)}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // if searched
                      <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                        <div className="row align-items-center t-pl-15 t-pr-15">
                          <div className="col-md-7 t-mb-15 mb-md-0">
                            <ul className="t-list d-flex">
                              <li className="t-list__item no-pagination-style">
                                <button
                                  className="btn btn-primary btn-sm rounded"
                                  onClick={() =>
                                     setSearchedPackingType({
                                      ... searchedPackingType,
                                      searched: false,
                                    })
                                  }
                                >
                                  {_t(t("Clear Search"))}
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-5">
                            <ul className="t-list d-flex justify-content-md-end align-items-center">
                              <li className="t-list__item">
                                <span className="d-inline-block sm-text">
                                  {searchedShowingData(
                                     searchedPackingType,
                                     packingTypeForSearch
                                  )}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ),
                  ]}
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
    </>
  );
};

export default PackingTypeList;
